import { render, staticRenderFns } from "./BirthdayTable.vue?vue&type=template&id=5b2c5e76&"
import script from "./BirthdayTable.vue?vue&type=script&lang=js&"
export * from "./BirthdayTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports